export default {
  label: {
    saveTooltip: 'Salvar',
    cancelTooltip: 'Cancelar',
  },
};
